import { ImageId, isImageId, DEFAULT_IMAGE_ID } from './images';
import { CelebrationType } from './types';

export function getCelebrationType(
  imageId: ImageId | string | null,
): CelebrationType {
  return isImageId(imageId) ? imageId : DEFAULT_IMAGE_ID;
}
